import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import InfoModal from '../InfoModal'
import Button from '../../../../components/Button'
import ProgressButton from '../../../../components/Form/ProgressButton'
import Icon from '../../../../components/Icon'
import { ReactComponent as EnvelopeIcon } from '../../../../assets/icons/envelope.svg'

import useModalManage from '../../../../hooks/useModalManage'
import { showToasts } from '../../../../helpers/toasts'

import {
  outstandingActionsNotificationErrorSelector,
  outstandingActionsNotificationIsLoadingSelector,
  outstandingActionsNotificationWasLoadedSelector,
  selectedPartnershipSelector
} from '../../../../modules/selectors/partnerships'
import {
  clearOutstandingActionsNotification,
  sendOutstandingActionsNotification
} from '../../../../modules/actions/partnerships'

import { TOAST_TYPE } from '../../../../constants/other'

import useStyles from './styles'

const OutstandingActionsReminderModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const classes = useStyles()

  const { isModalOpened, openModalHandler, closeModalHandler } = useModalManage({})

  const notificationIsLoading = useSelector(outstandingActionsNotificationIsLoadingSelector)
  const notificationWasSent = useSelector(outstandingActionsNotificationWasLoadedSelector)
  const notificationError = useSelector(outstandingActionsNotificationErrorSelector)

  const { partner_name: partnerName, id: partnershipId } = useSelector(selectedPartnershipSelector)

  const handleModalClose = useCallback(() => {
    closeModalHandler()
  }, [closeModalHandler])

  const successSubmitHandler = useCallback(() => {
    handleModalClose()
    showToasts({
      type: TOAST_TYPE.success,
      message: 'Notifications were sent'
    })
    dispatch(clearOutstandingActionsNotification())
  }, [dispatch, handleModalClose])

  const sendOutstandingActionsNotificationHandler = useCallback(() => {
    dispatch(sendOutstandingActionsNotification(partnershipId))
  }, [dispatch, partnershipId])

  return (
    <>
      <Button className={classes.outstandingActionsReminder} onClick={openModalHandler}>
        <Icon>
          <EnvelopeIcon />
        </Icon>
        {t('Outstanding Actions Reminder')}
      </Button>
      <InfoModal
        isOpen={isModalOpened}
        onClose={handleModalClose}
        modalTitle={`Send an email to ${partnerName} users reminding them that there are outstanding actions on their account.`}
        Buttons={
          <>
            <Button primary={false} onClick={handleModalClose}>
              {t('Cancel')}
            </Button>
            <ProgressButton
              formError={notificationError}
              isFormLoading={notificationIsLoading}
              successSubmit={notificationWasSent}
              onErrorSubmit={handleModalClose}
              onSuccessSubmit={successSubmitHandler}
              onClick={sendOutstandingActionsNotificationHandler}
            >
              {t('Send Email')}
            </ProgressButton>
          </>
        }
      />
    </>
  )
}

export default OutstandingActionsReminderModal
